import axios from "axios";
import { API_URL_SQL } from "../utils/Constant";

export const migrate = async (payload) => {
  try {
    const { date, category } = payload;
    const response = await axios.get(`${API_URL_SQL}/migrate/`, {
      params: { date, category },
    });
    const data = response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e.response?.data?.message || "Something went wrong";
    return { success: false, message };
  }
};

export const migrateCheckDuplicate = async (payload) => {
  try {
    const response = await axios.get(`${API_URL_SQL}/checkduplicates/`, {
      params: { date: payload },
    });
    const data = response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e.response?.data?.message || "Something went wrong";
    return { success: false, message };
  }
};

export const migrateDelete = async (payload) => {
  try {
    const response = await axios.get(`${API_URL_SQL}/deleteduplicates/`, {
      params: { date: payload },
    });
    const data = response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e.response?.data?.message || "Something went wrong";
    return { success: false, message };
  }
};
